import { z } from 'zod'
import { AUDIT_STAGES } from '../types.ts'

const DATE = /^\d{4}-\d{2}-\d{2}$/

/** The wizard's form, colocated with the form (§10.1): pipelines, period, cutoff, stages, quota, providers. */
export const createAuditSchema = z
  .object({
    title: z.string().trim().min(1, 'required'),
    pipelineIds: z.array(z.string()).min(1, 'pipelines'),
    periodFrom: z.string().regex(DATE, 'date'),
    periodTo: z.string().regex(DATE, 'date'),
    cutoffAt: z.union([z.literal(''), z.string().regex(DATE, 'date')]),
    stages: z
      .array(z.string().refine((s) => (AUDIT_STAGES as readonly string[]).includes(s), 'stages'))
      .min(1, 'stages'),
    asrMinutes: z.coerce.number().min(0, 'nonNegative'),
    llmTokens: z.coerce.number().min(0, 'nonNegative'),
    amount: z.coerce.number().min(0, 'nonNegative'),
    currency: z.string().trim().min(1, 'required'),
    asr: z.string().trim(),
    llm: z.string().trim(),
    llmModel: z.string().trim(),
  })
  .refine((v) => v.periodFrom < v.periodTo, { path: ['periodTo'], message: 'periodOrder' })
  .refine((v) => v.cutoffAt === '' || v.cutoffAt >= v.periodTo, {
    path: ['cutoffAt'],
    message: 'cutoffOrder',
  })
  .refine((v) => v.stages.includes('snapshot'), { path: ['stages'], message: 'snapshotRequired' })

export type CreateAuditFormValues = z.infer<typeof createAuditSchema>

export const CREATE_AUDIT_DEFAULTS: CreateAuditFormValues = {
  title: '',
  pipelineIds: [],
  periodFrom: '',
  periodTo: '',
  cutoffAt: '',
  stages: [...AUDIT_STAGES],
  asrMinutes: 600,
  llmTokens: 2_000_000,
  amount: 15_000,
  currency: 'EUR',
  asr: '',
  llm: '',
  llmModel: '',
}
